/**
 * MSAL (Entra/AAD) SPA configuration.
 *
 * TAKSIKORTTI is served through Azure Front Door on the custom domain
 * `taksikortti.taksi.cloud`. SWA EasyAuth can't work there (its session cookie
 * pins to the SWA default hostname), so we authenticate client-side with
 * MSAL — same pattern as Taksi.UI.Payment / Management.
 *
 * Defaults target the dev app registration (the only env that exists
 * today). Override per environment with the `VITE_MSAL_*` build vars.
 */

import { LogLevel, type Configuration } from '@azure/msal-browser';

/** Taksikuutio AAD tenant. */
const TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID ?? '16b235d7-7e90-4ec4-b250-06a515d69e4a';
/** Shared "Taksikuutio - Domain" app registration (same as Payment UI). */
const CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID ?? '734fbabb-6217-4c5b-97b6-cee772fb48d5';

const REDIRECT_URI =
  import.meta.env.VITE_MSAL_REDIRECT_URI ??
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173');

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI,
  },
  cache: {
    // localStorage so the session survives a full page reload / new tab.
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

/**
 * Token request for the TAKSIKORTTI API. `<clientId>/.default` yields an access
 * token whose `aud` is the app id — the API validates exactly that.
 */
export const loginRequest = {
  scopes: [`${CLIENT_ID}/.default`],
  domainHint: 'taksikuutio.fi',
};
